import React from "react";

const Step4 = () => {
  return (
    <div className="mt-24 flex justify-center items-center">
      <div className="text-center">
        <h2 className="text-6xl font-semibold mb-4">Thank you</h2>
        <p className="text-3xl p-10">Your request has been submitted</p>
      </div>
    </div>
  );
};

export default Step4;
